<script lang="ts">
	import viewport from '$lib/util/useViewportAction';
	import { fade } from 'svelte/transition';

	export let defaultClass: string = '';
	export let containerClass: string = '';

	$: renderComponent = false;

	let screenSize: number;
</script>

<svelte:window bind:innerWidth={screenSize} />
<div
	class="w-full"
	use:viewport
	on:enterViewport={() => {
		renderComponent = true;
	}}
	on:exitViewport={() => {
		renderComponent = false;
	}}
>
	{#if renderComponent}
		<div in:fade={{ delay: 0 }} class={containerClass}>
			<slot />
		</div>
	{:else}
		<div class={defaultClass} />
	{/if}
</div>
